import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Integration, IntegrationType } from '@pdqdev/pdq-shared/dist/entities';
import { IntegrationsService } from '@services/integrations/integrations.service';

@Component({
  selector: 'judge-me-settings',
  templateUrl: './judge-me-settings.component.html',
  styleUrls: ['./judge-me-settings.component.scss'],
  standalone: false,
})
export class JudgeMeSettingsComponent implements OnInit {
  @Input() integrationType?: IntegrationType;
  @Input() integration?: Integration;

  judgeMeApiToken: string = '';

  private destroyRef = inject(DestroyRef);

  constructor(private integrationService: IntegrationsService) {}

  ngOnInit(): void {
    this.integrationService.integrations$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((integrations) => {
      if (!this.integrationType) return;
      this.integration = integrations[this.integrationType.name]?.instance;
      this.judgeMeApiToken = this.integration?.metadata?.judgeMeApiToken ?? '';
    });
  }
}
